<template>
  <div class="page">
    <h5 class="title">分配预算设计师</h5>
    <!-- 弹窗 -->
    <van-form @submit="onSubmit">
      <van-field v-model="params.fullName" name="empId" label="指定预算设计师" placeholder="请选择指定预算设计师" :rules="rules.empId"
        required readonly clickable @click="showPickerEmpId = true" label-width="1rem" />
      <van-field v-model="params.manageName" name="manageId" label="指定设计单位" placeholder="请选择指定设计单位"
        :rules="rules.manageId" readonly clickable @click="showPickerManageId = true" label-width="1rem" />
      <van-field v-model="params.workDay" name="workDay" label="预算设计工期" placeholder="请填写预算设计工期" :rules="rules.workDay"
        required label-width="1rem" />
      <div class="tips">
        tips:预算设计工期=该节点办理完成日期+该处设置的工期天数
      </div>
      <div style="margin: 16px;">
        <van-button block type="info" size="small" native-type="submit">确 认</van-button>
      </div>
    </van-form>
    <!-- 指定设计师弹窗 -->
    <van-popup v-model="showPickerEmpId" round position="bottom" get-container="#app">
      <van-picker show-toolbar :columns="handleEmpUsers" value-key="fullName" @cancel="showPickerEmpId = false"
        @confirm="onConfirmEmpId" :default-index="3" />
    </van-popup>
    <!-- 指定设计师单位弹窗 -->
    <van-popup v-model="showPickerManageId" round position="bottom" get-container="#app">
      <van-picker show-toolbar :columns="manageList" value-key="manageName" @cancel="showPickerManageId = false"
        @confirm="onConfirmManageId" />
    </van-popup>
  </div>
</template>

<script>
import { rules } from "@/utils/rules";
import { Toast } from "vant";
import { getHandleEmpUser, getManageList, getDealAction, getDealActionVo } from "@/api/task/task"
export default {
  name: "Reference",
  props: ['taskList', 'approveId', 'assigneeEventAction', 'processType', 'executionId'],
  data() {
    return {
      rules,
      params: {
        fullName: "",
        empId: '',
        manageName: "",
        manageId: '',
        workDay: '',
      },
      showPickerEmpId: false,
      handleEmpUsers: [],//指定设计师列表
      showPickerManageId: false,
      manageList: [],//指定设计单位
    }
  },
  mounted() {
    this.getDealActionVo();
    this.getHandleEmpUser();
    this.getManageList();
  },
  methods: {
    // 【请求】办理回显
    getDealActionVo() {
      let data = {
        processType: this.processType,
        executionId: this.executionId,
      };
      getDealActionVo(data).then(res => {
        if (res.success && res.data) {
          this.params = res.data;
        }
      })
    },

    // 【请求】设计师列表
    getHandleEmpUser() {
      let data = {
        workSheetRoleType: 1,
        approveId: this.approveId
      };
      getHandleEmpUser(data).then(res => {
        if (res.success && res.data) {
          this.handleEmpUsers = res.data;
        }
      })
    },

    // 【请求】施工单位
    getManageList() {
      let data = {
        manageShip: 2
      };
      getManageList(data).then(res => {
        if (res.success && res.data) {
          this.manageList = res.data;
        }
      })
    },

    // 【监听】点击设计师
    onConfirmEmpId(value) {
      console.log('value: ', value);
      this.params.fullName = value.fullName;
      this.params.empId = value.empId;
      this.showPickerEmpId = false;
    },

    // 【监听】点击设计单位
    onConfirmManageId(value) {
      this.params.manageName = value.manageName;
      this.params.manageId = value.manageId;
      this.showPickerManageId = false;
    },

    onSubmit() {
      let data = this.params;
      data.approveId = this.approveId;
      data.assigneeEventAction = this.assigneeEventAction;
      data.processType = this.processType;
      data.executionId = this.executionId;
      getDealAction(data).then(res => {
        if (res.success && res.data) {
          Toast(res.msg);
          this.$emit('reTransact')
        } else {
          Toast(res.msg);
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.title {
  padding: .15rem;
  font-size: .16rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tips {
  font-size: .12rem;
  color: #999;
  padding: .15rem;
}
</style>

